/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadStageCount } from './LeadStageCount';
import {
    LeadStageCountFromJSON,
    LeadStageCountFromJSONTyped,
    LeadStageCountToJSON,
} from './LeadStageCount';

/**
 * 
 * @export
 * @interface GetLeadStageCounts200Response
 */
export interface GetLeadStageCounts200Response {
    /**
     * 
     * @type {Array<LeadStageCount>}
     * @memberof GetLeadStageCounts200Response
     */
    data?: Array<LeadStageCount>;
}

/**
 * Check if a given object implements the GetLeadStageCounts200Response interface.
 */
export function instanceOfGetLeadStageCounts200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetLeadStageCounts200ResponseFromJSON(json: any): GetLeadStageCounts200Response {
    return GetLeadStageCounts200ResponseFromJSONTyped(json, false);
}

export function GetLeadStageCounts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeadStageCounts200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(LeadStageCountFromJSON)),
    };
}

export function GetLeadStageCounts200ResponseToJSON(value?: GetLeadStageCounts200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(LeadStageCountToJSON)),
    };
}

